import { CommonModule, NgClass } from '@angular/common';
import {
  Component,
  HostListener,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';

import { EmbedMicroappDirective } from '@shared/lib/directives';

@Component({
  selector: 'wu-bottom-sheet-layout',
  imports: [CommonModule, NgClass, EmbedMicroappDirective],
  standalone: true,
  templateUrl: './bottom-sheet-layout.component.html',
})
export class BottomSheetLayoutComponent implements OnInit {
  readonly isOpened = input(false);
  readonly closed = output();
  readonly isDesktop = signal(window.innerWidth >= 1024);
  readonly showGlobalSearch = input(true);

  ngOnInit(): void {
    this.isDesktop.set(window.innerWidth >= 1024);
  }

  @HostListener('window:resize')
  onResize() {
    this.isDesktop.set(window.innerWidth >= 1024);
    if (this.isDesktop()) {
      this.close();
    }
  }

  @HostListener('window:close-BottomSheet')
  handleSearchClick(): void {
    this.close();
  }

  close() {
    this.closed.emit();
  }
}
